import { useField } from '@framework/form';
import { StyledDrawerCollapse } from '@framework/ui';
import { Collapse } from 'antd';
import { useWatch } from 'react-hook-form';
import {
  useAsyncServiceEngineContext,
  useTreeReferencesContext,
} from '../../../../../tree/references';
import { IWidgetComponentProps } from '../../../IWidgetType';
import { AsynceSelectServiceTableConfigForm } from '../async-select/components/service-config/AsynceSelectServiceTableConfigForm';
import { ServiceSelectorInput } from '../async-select/components/ServiceSelectorInput';
import { CommonConfigComponent } from '../common/CommonInputConfigComponent';
import { IAsyncTableWidget } from './IAsyncTableWidget';
const { Panel } = Collapse;

export interface IAsyncTableConfigComponentProps
  extends IWidgetComponentProps<IAsyncTableWidget> {}

export function AsyncTableConfigComponent(
  props: IAsyncTableConfigComponentProps,
) {
  const { services } = useAsyncServiceEngineContext();
  const { references } = useTreeReferencesContext();

  const { setValue: setOutputsField } = useField('outputs');

  const selectedId = useWatch({ name: `serviceId` });
  const selected = services.find(s => s.id === selectedId);

  const hasInputs = selected?.inputs && selected?.inputs.length > 0;

  return (
    <StyledDrawerCollapse defaultActiveKey={['general', 'service']} ghost>
      <Panel header="Impostazioni Generali" key="general">
        <CommonConfigComponent
          {...props}
          hideConfigDefaultValue
          hideConfigPlaceholder
          hideConfigHelpText
          hideConfigLabel
        />
      </Panel>
      <Panel header="Impostazioni Servizio" key="service">
        <div>
          <ServiceSelectorInput
            onChange={(value, option, onChange) => {
              onChange(value);
              setOutputsField((option as any).service.outputs);
            }}
            name="serviceId"
          />

          {/* Configurazione I/O servizio (modalità tabella) */}
          <AsynceSelectServiceTableConfigForm
            selected={selected}
            hasInputs={hasInputs}
            references={references}
            hasValue={false}
          />
        </div>
      </Panel>
    </StyledDrawerCollapse>
  );
}
